import React from "react";
import { motion } from "framer-motion";
import roadmap from "../components/images/roadmap.png";

const Roadmap: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "20px auto",
        padding: "0 20px",
      }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        style={{
          backgroundColor: "#1e1e1e",
          borderRadius: "20px",
          padding: "30px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
          maxWidth: "800px",
          width: "100%",
          marginBottom: "20px",
        }}
      >
        <h2
          style={{
            fontFamily: "'Psychedelic Font', cursive",
            color: "#FFFFFF", // Maak de tekst wit
          }}
        >
          Roadmap to Memetic Glory
        </h2>
        <p style={{ fontSize: "1.2rem", lineHeight: "1.6", color: "#FFFFFF" }}>
          {" "}
          {/* Maak de tekst wit */}
          <strong>Phase 1: Meme Madness</strong> - Launching like a rocket!
          Watch as we unleash the memes, make our mark, and have a few laughs
          along the way!
        </p>
        <p style={{ fontSize: "1.2rem", lineHeight: "1.6", color: "#FFFFFF" }}>
          {" "}
          {/* Maak de tekst wit */}
          <strong>Phase 2: Chill and HODL</strong> - Time to kick back! Embrace
          the vibes, grab your favorite snack, and hold onto your $METH as we
          ride the wave of memetic momentum!
        </p>
        <p style={{ fontSize: "1.2rem", lineHeight: "1.6", color: "#FFFFFF" }}>
          {" "}
          {/* Maak de tekst wit */}
          <strong>Phase 3: Meme Takeover!</strong> - The final countdown! It’s
          time for memes to reign supreme! We’ll dominate social media, create
          hilarious content, and show the world what $METH is made of!
        </p>

        {/* Plaats de afbeelding hier binnen de motion.div */}
        <img
          src={roadmap}
          alt="Roadmap"
          style={{
            borderRadius: "20px",
            height: "auto",
            width: "100%",
            maxWidth: "300px",
            marginTop: "20px", // Voeg wat ruimte toe boven de afbeelding
          }}
        />
      </motion.div>
    </div>
  );
};

export default Roadmap;
